export const LOCATION_FIELD_KEYS = [
    'address1',
    'address2',
    'stateName',
    'county',
    'city',
    'postalCode',
    'country'
];
